import DealerRewardPointPanel from "./dealerRewardPointPanel.container"

export default DealerRewardPointPanel
